<div class="ibox-content">
    <form [formGroup]="form">
      <div class="form-group row">
        <mat-error *ngIf="MensajeError" class="eliminacionInvalida">{{MensajeError}}</mat-error>
        <mat-error *ngIf="MensajeRetro && !MensajeError && formHabilitado" class="eliminacionInvalida">{{MensajeRetro}}</mat-error>
      </div>
      <div class="row" hidden="true">
        <input formControlName="id" name="id" type="text" class="form-control" />
        <input formControlName="personal" name="personal" type="text" class="form-control" />
      </div>
      <div class="row panel panel-warning" *ngIf="!disabledEditing">
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="desde">Desde</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="desde" dateFormat="dd/mm/yy" inputId="desde" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.desde.errors?.required && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error *ngIf="desdeAnterior && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al ingreso {{ingreso.desde | date:'dd/MM/yyyy'}}
            </mat-error>
            <mat-error *ngIf="anteriorRetroactividad && (registerFormControl.desde?.dirty || registerFormControl.desde?.touched || submitted)" class="text-danger">
              No puede ser anterior al límite de retroactividad {{grupoLiq.periodoRetroactividadNavigation.fechaDd | date:'dd/MM/yyyy'}}
            </mat-error>
          </div>
        </div>
        <div class="col-lg">
          <label class="col-lg-3 col-form-label font-bold" for="hasta">Hasta</label>
          <div class="col-lg-8">
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="hasta" dateFormat="dd/mm/yy" inputId="hasta" ngDefaultControl (ngModelChange)="onChangeFechas()"></p-calendar>
            <div *ngIf="registerFormControl.hasta.errors?.required && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)" class="text-danger">La Fecha es Requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.hasta.errors?.fecHastaMenor && (registerFormControl.hasta?.dirty || registerFormControl.hasta?.touched)">
                La Fecha no puede ser menor que la Fecha Desde
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
            <label class="col-form-label font-bold">Clase de Contingente</label>
            <div>
              <comboTools [list]=claseContingenteList
                          selected='claseContingente'
                          [formParent]="form"
                          [isEditing]=disabledEditing
                          filter="descripcion"
                          ph='Clase de Contingente'>
              </comboTools>
              <div *ngIf="registerFormControl.claseContingente.invalid && (
                registerFormControl.claseContingente?.dirty || registerFormControl.claseContingente?.touched || submitted)" class="text-danger">
                La Clase de Contingente es Requerida
              </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="col-form-label font-bold" for="inicioLiquidacion">Inicio Liquidación</label>
          <div>
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="inicioLiquidacion" dateFormat="dd/mm/yy" inputId="inicioLiquidacion" ngDefaultControl></p-calendar>
            <div *ngIf="registerFormControl.inicioLiquidacion.errors?.required && (registerFormControl.inicioLiquidacion?.dirty || registerFormControl.inicioLiquidacion?.touched || submitted)" class="text-danger">La Fecha Inicio es requerida</div>
          </div>
          <mat-error  class="text-danger" *ngIf="registerFormControl.inicioLiquidacion.errors?.fecHastaMenor && (registerFormControl.inicioLiquidacion?.dirty || registerFormControl.inicioLiquidacion?.touched || submitted)">
            La Fecha no puede ser menor que la Fecha Desde
          </mat-error>
        </div> 
        <div class="col-md-6">
          <label class="col-form-label font-bold" for="finLiquidacion">Fin Liquidación</label>
          <div>
            <p-calendar appendTo="body" selectOtherMonths="true" formControlName="finLiquidacion" dateFormat="dd/mm/yy" inputId="finLiquidacion" ngDefaultControl></p-calendar>
            <div *ngIf="registerFormControl.finLiquidacion.errors?.required && (registerFormControl.finLiquidacion?.dirty || registerFormControl.finLiquidacion?.touched || submitted)" class="text-danger">La Fecha Fin es requerida</div>
            <mat-error  class="text-danger" *ngIf="registerFormControl.finLiquidacion.errors?.fecHastaMenor && (registerFormControl.finLiquidacion?.dirty || registerFormControl.finLiquidacion?.touched || submitted)">
              La Fecha no puede ser menor que la Fecha Inicio
            </mat-error>
          </div>
        </div> 
      </div>
      <div class="row">
        <div class="col-md-6">
            <label class=" col-form-label font-bold">Cantidad</label>
            <input formControlName="cantidad" name ="selectedCantidad" type="number" class="form-control"  [ngClass]="{ 'is-invalid': registerFormControl.cantidad.errors && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)}"/>
            <mat-error  class="text-danger"*ngIf="registerFormControl.cantidad.errors?.required && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)">
                La Cantidad es Requerida
            </mat-error>
            <mat-error *ngIf="registerFormControl.cantidad.errors?.menorConsumo && (registerFormControl.cantidad?.dirty || registerFormControl.cantidad?.touched || submitted)" class="text-danger">
                No puede ser menor que la cantidad que ya se consumió
            </mat-error>
        </div>
        <div class="col-md-6">
            <label class=" col-form-label font-bold">Cantidad Consumida</label>
            <input formControlName="cantidadConsumida" name ="consumo" type="number" class="form-control" disabled/>
        </div>
      </div>
    </form>
  </div>
  
  